<!-- insurance-offers.html -->
<div class="insurance-offers-widget" [ngClass]="{'insurance-offers-widget--full': size === 'full'}">
  <!-- Header with Title + Pencil Edit -->
  <div class="insurance-header">
    <div class="insurance-title">Insurance Offers</div>
    <ng-container *ngIf="isEditMode">
      <div class="pencil-wrapper" (click)="toggleSizeDropdown(index, $event)" cdkOverlayOrigin
        #editTrigger="cdkOverlayOrigin">
        <img src="assets/icons/img-pencil.svg" class="pencil-icon" alt="Edit size" />
      </div>
      <!-- Size Dropdown -->
      <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
        [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize" [removeWidget]="removeWidget"
        [toggleSizeDropdown]="toggleSizeDropdown">
      </app-widget-edit>
    </ng-container>
    <ng-container *ngIf="isAddMode">
      <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png" alt="Settings"
        (click)="addWidget.emit(); $event.stopPropagation()" />
    </ng-container>
  </div>

  <!-- Main Scrollable Content -->
  <div class="insurance-inner">
    <!-- Offer 1 -->
    <div class="offer-item">
      <div class="offer-row">
        <div class="logo-placeholder">
          <img class="no-dark-filter" src="assets/icons/img-frame-1454.svg" alt="Insurance Logo 1" />
        </div>
        <button class="view-btn">View</button>
      </div>
      <div class="offer-desc">xxx xxxxxxxx xxxxxxx xxxx</div>
    </div>

    <div class="divider"></div>

    <!-- Offer 2 - State Farm -->
    <div class="offer-item">
      <div class="offer-row">
        <div class="logo-placeholder">
          <img class="no-dark-filter" src="assets/icons/statefarm-logo.png" alt="State Farm Logo" />
        </div>
        <button class="view-btn">View</button>
      </div>
      <div class="offer-desc">xxx xxxxxxxx xxxxxxx xxxx</div>
    </div>

    <div class="divider"></div>

    <!-- Offer 3 - Sun Life -->
    <div class="offer-item">
      <div class="offer-row">
        <div class="logo-placeholder">
          <img class="no-dark-filter" src="assets/icons/sunlife-logo.png" alt="Sun Life Logo" />
        </div>
        <button class="view-btn wide">View</button>
      </div>
      <div class="offer-desc">xxx xxxxxxxx xxxxxxx xxxx</div>
    </div>
  </div>
</div>